export const version = "bytes/5.0.3";
//# sourceMappingURL=_version.js.map